// extracted by mini-css-extract-plugin
export default {"BookRatingForm":"BookRatingForm_BookRatingForm__OnF55","Stars":"BookRatingForm_Stars__bdEfi"};